<template>
    <div class="grid grid-cols-12">
        <div
            class="hidden md:block col-span-12 md:col-span-2 bg-stone-100 min-h-screen h-full"
        >
            <div class="h-full border-r border-stone-200 bg-white">
                <div class="sticky top-0">
                    <AdminSidebar
                        :appName="appName"
                        :currentRoute="currentRoute"
                    />
                </div>
            </div>
        </div>
        <div class="block md:hidden col-span-12 md:col-span-2 bg-stone-100">
            <AdminMobileTopbar
                :appName="appName"
                :currentRoute="currentRoute"
            />
        </div>
        <div class="col-span-12 md:col-span-10">
            <PageWrapper
                :pageMeta="pageMeta"
                :authUser="authUser"
                :authCompanyUser="authCompanyUser"
                :impersonating="impersonating"
            >
                <template #left>
                    <slot name="left" />
                </template>
                <template #right>
                    <slot name="right" />
                </template>
                <slot />
            </PageWrapper>
        </div>

        <FlashMessage />
    </div>
</template>

<script setup lang="ts">
    import { onBeforeMount } from 'vue'
    import AdminSidebar from '@/Shared/Layout/Admin/AdminSidebar.vue'
    import AdminMobileTopbar from '@/Shared/Layout/Admin/AdminMobileTopbar.vue'
    import PageWrapper from '@/Shared/Layout/Admin/PageWrapper.vue'
    import FlashMessage from '@/Shared/Component/FlashMessage.vue'
    import {
        type FlashStatusType,
        type PageMeta,
    } from '@/Shared/AutoGenerated/Main'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import useFlash from '@/Shared/Hook/useFlash'

    interface AdminLayoutProps {
        pageMeta: PageMeta
        appName: string
        currentRoute: string
        authUser: User
        authCompanyUser: CompanyUser
        impersonating: boolean
        flashStatus: FlashStatusType | null
    }

    const props = defineProps<AdminLayoutProps>()

    onBeforeMount(() => {
        if (!props.flashStatus) {
            return
        }

        useFlash().display(props.flashStatus)
    })
</script>
